export default {
  image: 'A2_3.png',
  pdf: '220922_WA-HWF_003_A2_3_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-HWF-003',
    technicalValues: {
      soundReductionIndex: {
        output: '51,8',
        value: 51.8
      },
      heatTransferCoefficient: {
        output: '0,18',
        value: 0.18
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Holzweichfaser l Aufbau 3',
    construction: {
      composition: [
        {
          output: 'ohne',
          type: 'render',
          title: { de: 'Putz' },
          value: null
        },
        {
          output: '80 mm Sto-Weichfaserplatte M042',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'wmo42-80'
        },
        {
          output: 'ohne',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: null
        },
        {
          output: '60/140',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-140'
        },
        {
          output: '140 mm Holzwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'ciww-140'
        },
        {
          output: '15 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ib-15'
        },
        {
          output: '12,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'if-12'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '247,5',
        value: 247.5
      }
    }
  }
}
